import { formatLicensePlate } from '../../../services';
import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';
@Component({
    tag: 'web-license-plate',
    shadow: false
})
export class WebLicensePlate {
    /**
     * The country code of the license plate
     */
    @Prop() countryCode: string = 'nl';

    /**
     * Input name
     */
    @Prop() name: string = 'licensePlate';

    /**
     * Input placeholder text
     */
    @Prop() placeholderText: string = 'Uw kenteken';

    /**
     * Optional prefilled value for the component
     */
    @Prop() value: string = '';

    @State() inputValue: string = '';

    /**
     * Emits the input value as a string for every onInput value change.
     */
    @Event() valueEmitted: EventEmitter<string>;

    connectedCallback() {
        this.value = this.formatLicensePlate(this.value);
    }

    private formatLicensePlate(value: string) {
        const country = this.countryCode.toUpperCase();
        return formatLicensePlate(value, country);
    }

    private handleInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const value = this.formatLicensePlate(input.value);

        this.inputValue = input.value = value;
        this.valueEmitted.emit(this.inputValue);
    }

    render() {
        const { placeholderText, countryCode, name, value } = this;

        return (
            <div class="web-license-plate-container">
                <div class="country-code">
                    <web-icon name="eu-stars"></web-icon>
                    <span class="country-code__label">{countryCode}</span>
                </div>
                <label htmlFor={name} class="screen-reader-only">
                    {placeholderText}
                </label>
                <input
                    type="text"
                    name={name}
                    id={name}
                    value={value}
                    placeholder={placeholderText}
                    onInput={(e) => this.handleInputChange(e)}
                ></input>
            </div>
        );
    }
}
